import React from 'react';

const Logo = ({ color = 'white', width = '300px', className = '' }) => {
  return (
    <svg 
      width={width} 
      height="auto" 
      viewBox="0 0 400 150" 
      xmlns="http://www.w3.org/2000/svg" 
      className={className}
      style={{ maxWidth: '100%' }}
    >
      {/* Vote checkmark icon */}
      <circle cx="50" cy="75" r="40" fill={color} opacity="0.15"/>
      <path 
        d="M 30 75 L 45 90 L 70 60" 
        stroke={color} 
        strokeWidth="6" 
        fill="none" 
        strokeLinecap="round" 
        strokeLinejoin="round"
      />
      
      {/* VoteWave text */}
      <text 
        x="110" 
        y="90" 
        fontFamily="Arial, sans-serif" 
        fontSize="48" 
        fontWeight="800" 
        fill={color} 
        letterSpacing="-1"
      >
        VoteWave
      </text>
      
      {/* Wave underline */}
      <path 
        d="M 110 105 Q 150 95 190 105 T 270 105" 
        stroke={color} 
        strokeWidth="3" 
        fill="none" 
        opacity="0.8"
      />
    </svg>
  );
};

export default Logo;
